import { gql, type TypedDocumentNode } from '@apollo/client';
import { useTransition, animated } from '@react-spring/web';
import { SetCardBonus } from '@sorare/core/src/set/SetCardBonus/index.tsx';
import type { CardBonusWithTransition_skinEdition } from './__generated__/index.graphql.ts';

type Props = {
  skinEdition: CardBonusWithTransition_skinEdition;
};
export const CardBonusWithTransition = ({ skinEdition }: Props) => {
  const transition = useTransition([skinEdition], {
    from: { opacity: 0, transform: 'scale(2)' },
    enter: { opacity: 1, transform: 'scale(1)', delay: 300 },
    leave: {
      opacity: 0,
      transform: 'scale(1)',
    },
    exitBeforeEnter: true,
    config: {
      tension: 400,
      friction: 20,
    },
  });
  return transition((styles, { bonus, skin }) => {
    if (!bonus) {
      return null;
    }

    return (
      <animated.div style={styles}>
        <SetCardBonus power={bonus} skin={skin} />
      </animated.div>
    );
  });
};

CardBonusWithTransition.fragments = {
  skinEdition: gql`
    fragment CardBonusWithTransition_skinEdition on SkinEdition {
      bonus
      skin
    }
  ` as TypedDocumentNode<CardBonusWithTransition_skinEdition>,
};
